const yup = require("yup");

const createrefereerule = yup.object({
  firstname: yup.string().required("First name is a required field"),
  lastname: yup.string().required("Last name is a required field"),
  phonenumber: yup
    .string()
    .min(13, "Format not followed (23480xxxxxxxx)")
    .max(13, "Format not followed (23480xxxxxxxx)")
    .required("Phone number is a required field"),
  homeaddress: yup.string().required("Referee address is a required field"),
});

module.exports = {
  createrefereerule,
};
